/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useState } from "react";
import {
  Row,
  Col,
  Button,
  Label,
  Input,
  UncontrolledTooltip,
  Collapse,
} from "reactstrap";
import { withTranslation } from "react-i18next";
import "./CustomFormRepeaterRecursive.scss";

const CustomFormRepeater = ({ t, onChange, onDelete, value, ...props }) => {
  const [counter, setCounter] = useState(0);
  const [firstCol, setFirstCol] = useState(true);
  const [secondCol, setSecondCol] = useState([]);

  useEffect(()=>{
    if(value && value.children && value.children.length > 0){
      setSecondCol(value.children.map((ele)=> ({id: ele.id, isOpen: true })));
    }
  },[value]);

  const toggleFirstCol = useCallback(()=>{
    setFirstCol((old)=> !old);
  },[]);

  const toggleSecondCol = useCallback((id)=>{    
    setSecondCol((old)=> old.map((ele)=> ele.id === id ? ({ ...ele, isOpen: !ele.isOpen}) : ele));
  },[secondCol]);

  const handleChange0 = (e) => {
    onChange({ ...value, name: e });
  };

  const handleFriendlyName = (e) => {
    onChange({ ...value, friendlyName: e });
  };

  const handleHiddenChange0 = () => {
    onChange({ ...value, hidden: !value.hidden });
  };

  const handleChange1 = (e, id) => {
    onChange({
      ...value,
      children: value.children.map((item) =>
        item.id === id ? { ...item, name: e } : item
      ),
    });
  };

  const handleFriendlyName1 = (e, id) => {
    onChange({
      ...value,
      children: value.children.map((item) =>
        item.id === id ? { ...item, friendlyName: e } : item
      ),
    });
  };

  const handleHiddenChange1 = (id) => {
    onChange({
      ...value,
      children: value.children.map((item) =>
        item.id === id ? { ...item, hidden: !item.hidden } : item
      ),
    });
  };

  const handleChange2 = (e, id) => {
    onChange({
      ...value,
      children: value.children.map((element) => ({
        ...element,
        children: element?.children
          ? element.children.map((item2) =>
              item2.id === id ? { ...item2, name: e } : item2
            )
          : [],
      })),
    });
  };

  const handleFriendlyName2 = (e, id) => {
    onChange({
      ...value,
      children: value.children.map((element) => ({
        ...element,
        children: element?.children
          ? element.children.map((item2) =>
              item2.id === id ? { ...item2, friendlyName: e } : item2
            )
          : [],
      })),
    });
  };

  const handleHiddenChange2 = (id) => {
    onChange({
      ...value,
      children: value.children.map((element) => ({
        ...element,
        children: element?.children
          ? element.children.map((item2) =>
              item2.id === id ? { ...item2, hidden: !item2.hidden } : item2
            )
          : [],
      })),
    });
  };

  const handleAdd0 = (e) => {
    onChange({
      ...value,
      children: value?.children
        ? [
            ...value.children,
            {
              id: counter,
              name: "",
              children: [],
              hidden: false,
              hidden_operator: false,
              friendlyName: "",
            },
          ]
        : [
            {
              id: counter,
              name: "",
              children: [],
              hidden: false,
              hidden_operator: false,
              friendlyName: "",
            },
          ],
    });
    setCounter(counter + 1);
  };

  const handleAdd1 = (e) => {
    onChange({
      ...value,
      children: value.children.map((element) =>
        element.id === e.id
          ? {
              ...element,
              children: element.children
                ? [
                    ...element.children,
                    { id: counter, name: "", hidden: false,  hidden_operator: false, friendlyName: "" },
                  ]
                : [{ id: counter, name: "", hidden: false,  hidden_operator: false, friendlyName: "" }],
            }
          : { ...element }
      ),
    });
    setCounter(counter + 1);
  };

  const handleHiddenOperatorChange0 = () => {
    onChange({ ...value, hidden_operator: !value?.hidden_operator }); 
  };

  const handleHiddenOperatorChange1 = (id) => {   
    onChange({
      ...value,      
      children: value?.children.map((item) =>
        item.id === id ? { ...item, hidden_operator: !item?.hidden_operator } : item
      ),
    });      
  };

  const handleHiddenOperatorChange2 = (id) => {
    onChange({
      ...value,
      children: value?.children?.map((element) => ({
        ...element,
        children: element?.children
          ? element?.children?.map((item2) =>
              item2.id === id ? { ...item2, hidden_operator: !item2?.hidden_operator } : item2
            )
          : [],
      })),
    });    
  }; 

  return (
    <div ref={props?.register}>
      <Row className="d-flex">
        <Col sm="4" className="row">
          <div onClick={toggleFirstCol} className="d-flex icon-div pb-3">
              <span className={`icon-collaps-tabs ${firstCol ? 'opened' : 'closed'}`}>
                <i
                  className={`bx bx bxs-chevron-right`}
                />
              </span>
          </div>
          <div className="d-flex">            
            <div className="text-center align-self-center pb-3 pl-1 pr-3">
              <span className="mr-2">1</span>
            </div>
            <input
              className="form-control"
              type="text"
              placeholder={props?.placeholder}
              value={value?.name ?? ""}
              onChange={(e) => handleChange0(e.target.value)}
            />
          </div>
        </Col>
        <Col sm="3">
          <input
            className="form-control"
            type="text"
            placeholder={t("Friendly term")}
            value={value?.friendlyName ?? ""}
            onChange={(e) => handleFriendlyName(e.target.value)}
          />
        </Col>
        <Col className="mb-3 mt-auto" sm="3">
          <Row>
            <Col>
              <Button
                type="button"
                color="primary"
                className="w-100"
                disabled={false}
                onClick={() => {
                  handleAdd0(value);
                }}
              >
                <i className="mdi mdi-plus mr-1" />
                {props.addButtonText}
              </Button>
            </Col>
            <Col className="pl-0" sm="2" />
          </Row>
        </Col>
        <Col className="col-sm-12 d-flex pl-5" sm="12">
          <Col className="pt-2 pl-5" sm="3">
            <Input
              style={{ alignItems: "baseline" }}
              id="checkbox"
              type="checkbox"
              checked={value.hidden}
              onClick={handleHiddenChange0}
            />
            <Label className="pt-1" check onClick={handleHiddenChange0}>
              <p id="tooltip">{t("Hide from tracking")}</p>
            </Label>
            <UncontrolledTooltip
              placement="top"
              target="tooltip"
              className="uncontrolledTooltip"
            >
              {t(
                "If this tabulation is linked to a ticket, it will not will appear to the customer in the ticket detail."
              )}
            </UncontrolledTooltip>
          </Col>
          <Col className="pt-2 pl-0" sm="3">
            <Input
              style={{ alignItems: "baseline" }}
              id="checkbox"
              type="checkbox"
              checked={value.hidden_operator}
              onClick={handleHiddenOperatorChange0}
            />
            <Label className="pt-1" check onClick={handleHiddenOperatorChange0}>
              <p id="tooltipOperator">{t("Hide from operator")}</p>
            </Label>
            <UncontrolledTooltip
              placement="top"
              target="tooltipOperator"
              className="uncontrolledTooltip"
            >
              {t(
                "If it is marked as true, it does not appear for the tabular operator"
              )}
            </UncontrolledTooltip>
          </Col>
        </Col>        
      </Row>
      {value?.children?.map((element1, key1) => (
        <div key={key1}>
           <Collapse isOpen={firstCol}>  
            <Row className="d-flex pl-2">
              <Col className="d-flex" sm="4">
                <div onClick={()=>{
                  toggleSecondCol(element1.id);
                }} className="d-flex icon-div pb-3">
                    <span className={`icon-collaps-tabs ${ (secondCol?.find((ele)=> ele.id === element1.id))?.isOpen === true ? 'opened' : 'closed'}`}>
                      <i
                        className={`bx bx bxs-chevron-right`}
                      />
                    </span>
                </div>
                <div className="d-flex">
                  <div className="text-center align-self-center pl-3 pr-3 pb-3">
                    <span className="mr-2">{`1.${key1 + 1}`}</span>
                  </div>
                  <input
                    className="form-control"
                    type="text"
                    value={element1?.name ?? ""}
                    onChange={(e) => handleChange1(e.target.value, element1.id)}
                  />
                </div>
              </Col>
              <Col sm="3">
                <input
                  className="form-control"
                  type="text"
                  placeholder={t("Friendly term")}
                  value={element1?.friendlyName ?? ""}
                  onChange={(e) =>
                    handleFriendlyName1(e.target.value, element1.id)
                  }
                />
              </Col>
              <Col className="mb-3 mt-auto" sm="3">
                <Row>
                  <Col>
                    <Button
                      type="button"
                      color="success"
                      className="w-100"
                      disabled={false}
                      onClick={() => {
                        handleAdd1(element1);
                      }}
                    >
                      {props.addButtonText}
                    </Button>
                  </Col>
                  <Col className="pl-2 div-icon-trash-tab" sm="4">

                    <i
                      onClick={() => {
                        onDelete(element1, 1);
                      }} 
                      className={`bx bx bxs-trash icon-trash-tab 
                      ${element1.children != null && element1.children.length > 0 ? 'disabled w-100' : ''}`}></i>
                  </Col>
                </Row>
              </Col>
              <Col className="d-flex justify-flex-end pl-5" sm="12">
                <Col className="pt-2 pl-div-custom-checkbox" sm="3">
                  <Input
                    style={{ alignItems: "baseline" }}
                    id="checkbox1"
                    type="checkbox"
                    checked={element1.hidden}
                    onChange={() => handleHiddenChange1(element1.id)}
                  />
                  <Label
                    className="pt-1"
                    check
                    onClick={() => handleHiddenChange1(element1.id)}
                  >
                    <p id="tooltip1">{t("Hide from tracking")}</p>
                  </Label>
                  <UncontrolledTooltip placement="top" target="tooltip1">
                    {t(
                      "If this tabulation is linked to a ticket, it will not will appear to the customer in the ticket detail."
                    )}
                  </UncontrolledTooltip>
                </Col>
                <Col className="pt-2 pl-5" sm="3">
                  <Input
                    style={{ alignItems: "baseline" }}
                    id="checkbox1"
                    type="checkbox"
                    checked={element1.hidden_operator}
                    onChange={() => handleHiddenOperatorChange1(element1.id)}
                  />
                  <Label
                    className="pt-1"
                    check
                    onClick={() => handleHiddenOperatorChange1(element1.id)}
                  >
                    <p id="tooltipOperator1">{t("Hide from operator")}</p>
                  </Label>
                  <UncontrolledTooltip placement="top" target="tooltipOperator1">
                    {t(
                      "If it is marked as true, it does not appear for the tabular operator"
                    )}
                  </UncontrolledTooltip>
                </Col>
              </Col>            
            </Row>
            <Collapse isOpen={(secondCol?.find((ele)=> ele.id === element1.id))?.isOpen ?? false}>  
              {element1?.children?.map((element2, key2) => (
                <Row key={`tab-${key1}.${key2}`} className="d-flex pl-div-custom-nivel3">                
                  <Col className="tab-csat-col" sm="4">
                    <div className="d-flex ml-5">
                      <div className="text-center align-self-center pl-3 pr-3">
                        <span className="mr-2">{`1.${key1 + 1}.${key2 + 1}`}</span>
                      </div>
                      <input
                        className="form-control"
                        type="text"
                        value={element2?.name ?? ""}
                        onChange={(e) => {
                          handleChange2(e.target.value, element2.id);
                        }}
                      />
                    </div>
                  </Col>
                  <Col sm="3">
                    <input
                      className="form-control"
                      type="text"
                      placeholder={t("Friendly term")}
                      value={element2?.friendlyName ?? ""}
                      onChange={(e) =>
                        handleFriendlyName2(e.target.value, element2.id)
                      }
                    />
                  </Col>
                  <Col className="mb-3 mt-auto" sm="3">
                    <Row>
                      <Col>
                        <Button
                          type="button"
                          color="secondary"
                          className="isDisabled w-100 btn-add-disabled"
                          disabled={true}
                          onClick={() => {}}
                        >
                          {props.addButtonText}
                        </Button>
                      </Col>
                      <Col className="pl-0 pl-0 div-icon-trash-tab col-sm-4" sm="4">
                        <i
                        onClick={() => {
                          onDelete(element2, 2);
                        }} 
                      className={`bx bx bxs-trash icon-trash-tab`}></i>                        
                      </Col>
                    </Row>
                  </Col>
                  <Col className="d-flex justify-flex-end pl-div-custom-checkbox-nivell3" sm="12">
                    <Col className="pt-2 pl-5" sm="3">
                      <Input
                        style={{ alignItems: "baseline" }}
                        id="checkbox2"
                        type="checkbox"
                        checked={element2.hidden}
                        onChange={() => {
                          handleHiddenChange2(element2.id);
                        }}
                      />
                      <Label
                        className="pt-1"
                        check
                        onClick={() => {
                          handleHiddenChange2(element2.id);
                        }}
                      >
                        <p id="tooltip2">{t("Hide from tracking")}</p>
                      </Label>
                      <UncontrolledTooltip
                        placement="top"
                        target="tooltip2"
                        className="uncontrolledTooltip"
                      >
                        {t(
                          "If this tabulation is linked to a ticket, it will not will appear to the customer in the ticket detail."
                        )}
                      </UncontrolledTooltip>
                    </Col>
                    <Col className="pt-2 pl-5" sm="3">
                      <Input
                        style={{ alignItems: "baseline" }}
                        id="checkbox2"
                        type="checkbox"
                        checked={element2.hidden_operator}
                        onChange={() => {
                          handleHiddenOperatorChange2(element2.id);
                        }}
                      />
                      <Label
                        className="pt-1"
                        check
                        onClick={() => {
                          handleHiddenOperatorChange2(element2.id);
                        }}
                      >
                        <p id="tooltipOperator2">{t("Hide from operator")}</p>
                      </Label>
                      <UncontrolledTooltip
                        placement="top"
                        target="tooltipOperator2"
                        className="uncontrolledTooltip"
                      >
                        {t(
                          "If it is marked as true, it does not appear for the tabular operator"
                        )}
                      </UncontrolledTooltip>
                    </Col>  
                  </Col>
                </Row>
              ))}
            </Collapse>
          </Collapse>
        </div>
      ))}
    </div>
  );
};

export default withTranslation()(CustomFormRepeater);
